import React from 'react';

const ReveenDashboard = () => {
  return (
    <div>
      <h2>Reveen Dashboard</h2>
      <p>Welcome to the Reveen administration panel.</p>
    </div>
  );
};

export default ReveenDashboard;
